import { IconProps } from 'components/icons/types';

export const ArrowLeftIcon = (props: IconProps) => {
  const { width = 21, height = 20, className } = props;

  return (
    <svg className={className} width={width} height={height} viewBox='0 0 21 20' fill='none'
         xmlns='http://www.w3.org/2000/svg'>
      <path d='M16.3346 10.0013H4.66797M4.66797 10.0013L10.5013 15.8346M4.66797 10.0013L10.5013 4.16797'
            stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const ArrowLeftFreeIcon = (props: IconProps) => {
  const { width = 20, height = 20, className } = props;

  return (
    <svg className={className} width={width} height={height} viewBox='0 0 21 20' fill='none'
         xmlns='http://www.w3.org/2000/svg'>
      <mask id='mask0_8431_71587' maskUnits='userSpaceOnUse' x='0' y='0' width={width} height={height}>
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_8431_71587)'>
        <path
          d='M9.00065 9.99984L12.2507 13.2498C12.4034 13.4026 12.4798 13.5971 12.4798 13.8332C12.4798 14.0693 12.4034 14.2637 12.2507 14.4165C12.0979 14.5693 11.9034 14.6457 11.6673 14.6457C11.4312 14.6457 11.2368 14.5693 11.084 14.4165L7.25065 10.5832C7.16732 10.4998 7.10829 10.4096 7.07357 10.3123C7.03885 10.2151 7.02148 10.1109 7.02148 9.99984C7.02148 9.88873 7.03885 9.78456 7.07357 9.68734C7.10829 9.59012 7.16732 9.49984 7.25065 9.4165L11.084 5.58317C11.2368 5.43039 11.4312 5.354 11.6673 5.354C11.9034 5.354 12.0979 5.43039 12.2507 5.58317C12.4034 5.73595 12.4798 5.93039 12.4798 6.1665C12.4798 6.40262 12.4034 6.59706 12.2507 6.74984L9.00065 9.99984Z'
          fill='#1C1B1F' />
      </g>
    </svg>
  );
};


export const ArrowRightFreeIcon = (props: IconProps) => {
  const { width = 20, height = 20, className } = props;

  return (
    <svg className={className} width={width} height={height} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask id='mask0_8703_61916' maskUnits='userSpaceOnUse' x='0' y='0' width='20' height='20'>
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_8703_61916)'>
        <path
          d='M10.5007 10.0003L7.25065 6.75033C7.09787 6.59755 7.02148 6.4031 7.02148 6.16699C7.02148 5.93088 7.09787 5.73644 7.25065 5.58366C7.40343 5.43088 7.59787 5.35449 7.83398 5.35449C8.0701 5.35449 8.26454 5.43088 8.41732 5.58366L12.2507 9.41699C12.334 9.50033 12.393 9.5906 12.4277 9.68783C12.4625 9.78505 12.4798 9.88922 12.4798 10.0003C12.4798 10.1114 12.4625 10.2156 12.4277 10.3128C12.393 10.41 12.334 10.5003 12.2507 10.5837L8.41732 14.417C8.26454 14.5698 8.0701 14.6462 7.83398 14.6462C7.59787 14.6462 7.40343 14.5698 7.25065 14.417C7.09787 14.2642 7.02148 14.0698 7.02148 13.8337C7.02148 13.5975 7.09787 13.4031 7.25065 13.2503L10.5007 10.0003Z'
          fill='#F2F2F2' />
      </g>
    </svg>
  );
};
